import {NgModule} from '@angular/core';
import {CommonModule, DatePipe} from '@angular/common';
import {
  PrimaryButtonComponent
} from './components/buttons/primary-button/primary-button.component';
import {MaterialModule} from "./material-module";
import {
  PreventMultipleClickDirective
} from "./directive/prevent-multiple-click.directive";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {
  TextInputComponent
} from './components/form-fields/input/text-input/text-input.component';
import {
  InputRestrictionDirective
} from "./directive/input-restriction.directive";
import {
  NumberInputComponent
} from './components/form-fields/input/number-input/number-input.component';
import {OnlyDigitsDirective} from "./directive/only-digits.directive";
import {
  PasswordInputComponent
} from './components/form-fields/input/password-input/password-input.component';
import {IconComponent} from './components/icon/icon.component';
import {
  DropdownComponent
} from './components/form-fields/dropdown/dropdown.component';
import {
  DatePickerComponent
} from './components/form-fields/date-picker/date-picker.component';
import {MatDatetimepickerModule} from "@mat-datetimepicker/core";
import {DateDirective} from "./directive/date.directive";
import {DateFormatPipe} from "./pipes/date-format.pipe";
import {SafeUrlPipe} from "./pipes/safe-url.pipe";
import {SafeHTMLPipe} from "./pipes/safe-html.pipe";
import {
  UnauthenticatedWrapperComponent
} from './components/wrappers/unauthenticated-wrapper/unauthenticated-wrapper.component';
import {
  AuthenticatedWrapperComponent
} from './components/wrappers/authenticated-wrapper/authenticated-wrapper.component';
import {RouterModule} from "@angular/router";
import {
  PageNotFoundComponent
} from './components/page-not-found/page-not-found.component';
import {StoreModule} from "@ngrx/store";
import {reducer} from "./core/shared.reducer";
import {EffectsModule} from "@ngrx/effects";
import {SharedEffects} from "./core/shared.effects";
import {
  LineChartComponent
} from './components/charts/line-chart/line-chart.component';
import {
  BarChartComponent
} from './components/charts/bar-chart/bar-chart.component';
import {
  GroupedBarChartComponent
} from './components/charts/grouped-bar-chart/grouped-bar-chart.component';
import {
  PhoneNumberInputComponent
} from './components/form-fields/input/phone-number-input/phone-number-input.component';
import {PhoneNumberDirective} from './directive/phone-number.directive';
import {PhoneNumberFormatPipe} from './pipes/phone-number-format.pipe';
import {
  OtpInputComponent
} from './components/form-fields/input/otp-input/otp-input.component';
import {TableComponent} from './components/table/table.component';
import {
  DialogBoxComponent
} from './components/dialogbox/basic-dialog/dialog-box.component';
import {
  TextAreaInputComponent
} from './components/form-fields/input/text-area-input/text-area-input.component';
import {
  ToggleButtonComponent
} from './components/buttons/toggle-button/toggle-button.component';
import {BloodPressureDirective} from './directive/blood-pressure.directive';
import {BloodPressureFormatPipe} from './pipes/blood-pressure-format.pipe';
import {
  BloodPressureInputComponent
} from './components/form-fields/input/blood-pressure-input/blood-pressure-input.component';
import {
  FixedSideNavItemComponent
} from './components/fixed-side-nav-item/fixed-side-nav-item.component';
import {CdkConnectedOverlay, CdkOverlayOrigin} from "@angular/cdk/overlay";
import {
  SideNavProfileMenuComponent
} from './components/side-nav-profile-menu/side-nav-profile-menu.component';
import {
  ShimmerLoaderComponent
} from './components/shimmer-loader/shimmer-loader.component';
import {NgxSkeletonLoaderModule} from "ngx-skeleton-loader";
import {ImageComponent} from './components/image/image.component';
import {
  CheckBoxInputComponent
} from './components/form-fields/input/check-box-input/check-box-input.component';
import {
  SearchOnSelectComponent
} from './components/form-fields/search-on-select/search-on-select.component';
import {NgxMatSelectSearchModule} from "ngx-mat-select-search";
import {
  StepProgressIndicatorComponent
} from './components/step-progress-indicator/step-progress-indicator.component';
import {
  AvatarPanelComponent
} from "./components/avatar-panel/avatar-panel.component";
import {ProfileComponent} from "./pages/user-profile/profile/profile.component";
import {
  UpdatePasswordFormComponent
} from "./pages/update-password-form/update-password-form.component";
import {
  EditableUserDetailsComponent
} from "./pages/user-profile/components/user-details/editable-user-details/editable-user-details.component";
import {
  EditableOnboardingDetailsComponent
} from "./pages/user-profile/components/onboarding-details/editable-onboarding-details/editable-onboarding-details.component";
import {
  NonEditableOnboardingDetailsComponent
} from "./pages/user-profile/components/onboarding-details/non-editable-onboarding-details/non-editable-onboarding-details.component";
import {
  NonEditableUserDetailsComponent
} from "./pages/user-profile/components/user-details/non-editable-user-details/non-editable-user-details.component";
import {
  ConfirmationDialogComponent
} from './components/dialogbox/confirmation-dialog/confirmation-dialog.component';
import {FormHostDirective} from './directive/form-host.directive';
import {
  DateTimePickerComponent
} from './components/form-fields/date-time-picker/date-time-picker.component';
import {DatetimeDirective} from './directive/datetime.directive';
import {DatetimeFormatPipe} from './pipes/datetime-format.pipe';
import {DummyComponent} from './components/dummy/dummy.component';
import {
  RadioInputComponent
} from './components/form-fields/input/radio-input/radio-input.component';
import {TableHostDirective} from './directive/table-host.directive';
import {
  ClinicDetailsComponent
} from './pages/user-profile/components/clinic-details/clinic-details.component';
import {
  ParticipantDetailsComponent
} from './pages/user-profile/components/participant-details/participant-details.component';
import {
  AdultDetailsComponent
} from './pages/user-profile/components/adult-details/adult-details.component';
import {
  PageNotFoundLeftPanelComponent
} from './components/external-page-not-found/page-not-found-image/page-not-found-left-panel.component';
import {
  PageNotFoundRightPanelComponent
} from './components/external-page-not-found/page-not-found-text/page-not-found-right-panel.component';
import {
  ScreenSizeAlertComponent
} from './components/screen-size-alert/screen-size-alert.component';
import {
  EditPhoneNumberComponent
} from './pages/user-profile/components/edit-phone-number/edit-phone-number.component';
import {FilterHostDirective} from './directive/filter-host.directive';
import {
  HeightInputComponent
} from './components/form-fields/input/height-input/height-input.component';
import {HeightFormatPipe} from './pipes/height-format.pipe';
import {InfiniteScrollModule} from "ngx-infinite-scroll";
import {
  LoadingScreenComponent
} from './components/loading-screen/loading-screen.component';
import {
  SessionSchedulerDayComponent
} from './components/session-scheduler/session-scheduler-day/session-scheduler-day.component';
import {
  SessionSchedulerComponent
} from './components/session-scheduler/session-scheduler/session-scheduler.component';
import {
  TimePickerComponent
} from './components/form-fields/time-picker/time-picker.component';
import {
  PrintContainerComponent
} from './components/print-container/print-container.component';
import {TimerComponent} from './components/timer/timer.component';
import {
  NotificationDetailsPopupComponent
} from './components/notification-details-popup/notification-details-popup.component';
import {
  OpenNotificationConfirmationPopupComponent
} from './components/open-notification-confirmation-popup/open-notification-confirmation-popup.component';
import {
  FilterDropdownComponent
} from './components/form-fields/filter-dropdown/filter-dropdown.component';
import {
  UserDetailsShimmerLoaderComponent
} from './pages/user-profile/components/user-details/user-details-shimmer-loader/user-details-shimmer-loader.component';
import {
  PreventCopyPasteDirective
} from './directive/prevent-copy-paste.directive';
import {
  SecondsToHoursMinutesPipe
} from "./directive/seconds-to-hours-minutes.pipe";
import {CdnBaseUrlPipe} from './pipes/cdn-base-url.pipe';
import {
  GroupedBarChartTwoComponent
} from './components/charts/grouped-bar-chart-two/grouped-bar-chart-two.component';
import { GroupDetailsComponent } from './pages/user-profile/components/group-details/group-details.component';
import { HoursAndMinutesPipe } from './pipes/hours-and-minutes.pipe';
import { LogoutWarningComponent } from './components/logout-warning/logout-warning.component';
import { OldNewDateHandlingPipe } from './pipes/old-new-date-handling.pipe';
import { DownloadExpiredComponent } from './components/download-expired/download-expired.component';
import { PendingSurveyBadgeComponent } from './components/pending-survey-badge/pending-survey-badge.component';

@NgModule({
  declarations: [
    PrimaryButtonComponent,
    PreventMultipleClickDirective,
    TextInputComponent,
    InputRestrictionDirective,
    NumberInputComponent,
    OnlyDigitsDirective,
    PasswordInputComponent,
    IconComponent,
    DropdownComponent,
    DatePickerComponent,
    DateDirective,
    DateFormatPipe,
    SafeHTMLPipe,
    SafeUrlPipe,
    UnauthenticatedWrapperComponent,
    AuthenticatedWrapperComponent,
    PageNotFoundComponent,
    LineChartComponent,
    BarChartComponent,
    GroupedBarChartComponent,
    GroupedBarChartTwoComponent,
    OtpInputComponent,
    PhoneNumberInputComponent,
    PhoneNumberDirective,
    PhoneNumberFormatPipe,
    DialogBoxComponent,
    TableComponent,
    TextAreaInputComponent,
    ToggleButtonComponent,
    BloodPressureDirective,
    BloodPressureFormatPipe,
    BloodPressureInputComponent,
    FixedSideNavItemComponent,
    SideNavProfileMenuComponent,
    AvatarPanelComponent,
    ShimmerLoaderComponent,
    CheckBoxInputComponent,
    ImageComponent,
    SearchOnSelectComponent,
    ProfileComponent,
    UpdatePasswordFormComponent,
    EditableUserDetailsComponent,
    EditableOnboardingDetailsComponent,
    NonEditableOnboardingDetailsComponent,
    ConfirmationDialogComponent,
    NonEditableUserDetailsComponent,
    DummyComponent,
    DateTimePickerComponent,
    DatetimeDirective,
    DatetimeFormatPipe,
    RadioInputComponent,
    FormHostDirective,
    TableHostDirective,
    PageNotFoundLeftPanelComponent,
    PageNotFoundRightPanelComponent,
    ScreenSizeAlertComponent,
    TableHostDirective,
    ClinicDetailsComponent,
    ParticipantDetailsComponent,
    AdultDetailsComponent,
    FilterHostDirective,
    HeightInputComponent,
    HeightFormatPipe,
    EditPhoneNumberComponent,
    LoadingScreenComponent,
    SessionSchedulerDayComponent,
    SessionSchedulerComponent,
    TimePickerComponent,
    PrintContainerComponent,
    TimerComponent,
    NotificationDetailsPopupComponent,
    OpenNotificationConfirmationPopupComponent,
    FilterDropdownComponent,
    UserDetailsShimmerLoaderComponent,
    PreventCopyPasteDirective,
    SecondsToHoursMinutesPipe,
    CdnBaseUrlPipe,
    GroupDetailsComponent,
    HoursAndMinutesPipe,
    LogoutWarningComponent,
    OldNewDateHandlingPipe,
    DownloadExpiredComponent,
    PendingSurveyBadgeComponent,
    StepProgressIndicatorComponent,
  ],
  exports: [
    PrimaryButtonComponent,
    TextInputComponent,
    NumberInputComponent,
    PasswordInputComponent,
    DropdownComponent,
    DatePickerComponent,
    DateFormatPipe,
    DateDirective,
    LineChartComponent,
    BarChartComponent,
    GroupedBarChartComponent,
    GroupedBarChartTwoComponent,
    DateDirective,
    IconComponent,
    OtpInputComponent,
    IconComponent,
    PhoneNumberDirective,
    PhoneNumberFormatPipe,
    PhoneNumberInputComponent,
    IconComponent,
    DialogBoxComponent,
    TableComponent,
    TextAreaInputComponent,
    ToggleButtonComponent,
    BloodPressureInputComponent,
    FixedSideNavItemComponent,
    InputRestrictionDirective,
    ShimmerLoaderComponent,
    ImageComponent,
    CheckBoxInputComponent,
    SearchOnSelectComponent,
    AvatarPanelComponent,
    DateTimePickerComponent,
    RadioInputComponent,
    FormHostDirective,
    TableHostDirective,
    ScreenSizeAlertComponent,
    FilterHostDirective,
    HeightInputComponent,
    HeightFormatPipe,
    SessionSchedulerDayComponent,
    SessionSchedulerComponent,
    LoadingScreenComponent,
    TimePickerComponent,
    PrintContainerComponent,
    TimerComponent,
    FilterDropdownComponent,
    SecondsToHoursMinutesPipe,
    CdnBaseUrlPipe,
    HoursAndMinutesPipe,
    OldNewDateHandlingPipe,
    PendingSurveyBadgeComponent,
    StepProgressIndicatorComponent,
  ],
  imports: [
    CommonModule,
    MaterialModule,
    ReactiveFormsModule,
    MatDatetimepickerModule,
    RouterModule,
    StoreModule.forFeature('ss-cord.shared', reducer),
    EffectsModule.forFeature(
      [SharedEffects]
    ),
    FormsModule,
    CdkOverlayOrigin,
    CdkConnectedOverlay,
    NgxSkeletonLoaderModule,
    NgxMatSelectSearchModule,
    InfiniteScrollModule,
  ],
  providers: [
    DatePipe,
    DateFormatPipe,
    PhoneNumberFormatPipe,
    BloodPressureFormatPipe,
    HeightFormatPipe,
    CdnBaseUrlPipe,
    HoursAndMinutesPipe,
  ]
})
export class SharedModule {
}
